import { iCloudMetaFile } from '@cfx/icloud-upload';
import { RuntimeEnvManager } from '@dustess/iconfig-env-runtime';
import { getUser, getUserSid } from '@dustess/itimo-core';
import { interceptorsRequest, createAxios } from '@dustess/iquery';

function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return exports;
  };
  var exports = {},
    Op = Object.prototype,
    hasOwn = Op.hasOwnProperty,
    defineProperty = Object.defineProperty || function (obj, key, desc) {
      obj[key] = desc.value;
    },
    $Symbol = "function" == typeof Symbol ? Symbol : {},
    iteratorSymbol = $Symbol.iterator || "@@iterator",
    asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
    toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }
  try {
    define({}, "");
  } catch (err) {
    define = function (obj, key, value) {
      return obj[key] = value;
    };
  }
  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
      generator = Object.create(protoGenerator.prototype),
      context = new Context(tryLocsList || []);
    return defineProperty(generator, "_invoke", {
      value: makeInvokeMethod(innerFn, self, context)
    }), generator;
  }
  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }
  exports.wrap = wrap;
  var ContinueSentinel = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
    NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }
  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if ("throw" !== record.type) {
        var result = record.arg,
          value = result.value;
        return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }
      reject(record.arg);
    }
    var previousPromise;
    defineProperty(this, "_invoke", {
      value: function (method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }
        return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(innerFn, self, context) {
    var state = "suspendedStart";
    return function (method, arg) {
      if ("executing" === state) throw new Error("Generator is already running");
      if ("completed" === state) {
        if ("throw" === method) throw arg;
        return doneResult();
      }
      for (context.method = method, context.arg = arg;;) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }
        if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
          if ("suspendedStart" === state) throw state = "completed", context.arg;
          context.dispatchException(context.arg);
        } else "return" === context.method && context.abrupt("return", context.arg);
        state = "executing";
        var record = tryCatch(innerFn, self, context);
        if ("normal" === record.type) {
          if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
          return {
            value: record.arg,
            done: context.done
          };
        }
        "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
      }
    };
  }
  function maybeInvokeDelegate(delegate, context) {
    var methodName = context.method,
      method = delegate.iterator[methodName];
    if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }
  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }
  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }
  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;
      if (!isNaN(iterable.length)) {
        var i = -1,
          next = function next() {
            for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
            return next.value = undefined, next.done = !0, next;
          };
        return next.next = next;
      }
    }
    return {
      next: doneResult
    };
  }
  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), defineProperty(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (val) {
    var object = Object(val),
      keys = [];
    for (var key in object) keys.push(key);
    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function (skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function () {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function (exception) {
      if (this.done) throw exception;
      var context = this;
      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
          record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");
        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
            hasFinally = hasOwn.call(entry, "finallyLoc");
          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function (type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }
      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function (record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function (finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function (tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function (iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

var envManner = /*#__PURE__*/new RuntimeEnvManager();
var env = envManner.env;
var baseURL = env.VUE_APP_M_C_BASE_URL;
interceptorsRequest('Authorization', function (config) {
  var _getUser;
  var account = (_getUser = getUser('qw')) == null ? void 0 : _getUser.account;
  config.headers.Authorization = getUserSid('qw');
  account && (config.headers['x-auth-accountid'] = account);
});
var _createAxios = /*#__PURE__*/createAxios({
    baseURL: baseURL,
    // 自定义错误map
    errorMap: {}
  }),
  request = _createAxios.request;
function ajax(requestParams) {
  var method = requestParams.method,
    params = requestParams.params;
  if (method === 'GET') requestParams.query = params;else requestParams.data = params;
  return request(requestParams);
}

var envManner$1 = /*#__PURE__*/new RuntimeEnvManager();
var env$1 = envManner$1.env;
// 获取文件大小
var getFileSize = function getFileSize(url) {
  var user = getUser('qw');
  return iCloudMetaFile({
    service: {
      path: url
    },
    extra: {
      baseURL: env$1.VUE_APP_WEBGATEWAY_BASE_URL,
      header: {
        'x-auth-accountid': user.account,
        Authorization: getUserSid('qw')
      }
    }
  });
};
/**
 * 获取临时素材的media_id
 * @param params
 * @returns
 * @address https://developer.work.weixin.qq.com/document/path/90253
 */
var getMediaId = function getMediaId(params) {
  return ajax({
    url: '/material/center/v1/media/upload',
    method: 'POST',
    params: params
  });
};

/** 子模块 */
var SUB_DOMAIN;
(function (SUB_DOMAIN) {
  /** 企业文件夹 */
  SUB_DOMAIN["ORDINARY"] = "ordinary";
  /** 搜索助手 */
  SUB_DOMAIN["INTELLIGENT_SEARCH"] = "intelligent-search";
  /** 内容中心 */
  SUB_DOMAIN["CONTENT_CENTER"] = "content-center";
  /** 话术库 */
  SUB_DOMAIN["DIALOGUE_SCRIPT"] = "dialogue-script";
  /** 营销素材 */
  SUB_DOMAIN["MATERIAL"] = "material";
  /** 一客一码 */
  SUB_DOMAIN["CUSTOMER_CODE"] = "customer-code";
  /** 商品海报 */
  SUB_DOMAIN["GOODS_POSTER"] = "goods-poster";
})(SUB_DOMAIN || (SUB_DOMAIN = {}));

var MAX_FILE_SIZE = 20; // 文件大小
var MAX_IMAGE_SIZE = 10; // 图片大小
var MAX_VIDEO_SIZE = 10; // 视频大小
var MIN_FILE_SIZE = 5; // 最小的文件大小，单位为字节
/**
 * 错误码及错误信息映射Map
 * 1开头代表严重错误，2开头的代表使用错误或参数，3开头表示后端接口报错，5开头表示发送状态
 */
var errorMap = {
  100001: '企微SDK注册失败',
  100002: '发送异常，请重试',
  200001: '缺少参数或必填参数为空',
  200002: "\u6587\u4EF6\u5927\u4E8E" + MAX_FILE_SIZE + "M\uFF0C\u6682\u4E0D\u652F\u6301\u53D1\u9001",
  200003: '文件大小过低，暂不支持发送',
  300001: '文件大小获取失败',
  300002: '上传临时素材失败',
  500200: '发送成功',
  500201: '取消发送',
  500500: '发送失败'
};
/**
 * 校验必填参数是否正确
 * @param msgType 消息格式
 * @param sendParams 发送参数
 * @returns
 */
var validateParams = function validateParams(msgType, sendParams) {
  var commonKeys = ['mediaUrl', 'name', 'suffix', 'domain', 'subDomain'];
  var targetHashMap = {
    text: ['content'],
    image: commonKeys,
    video: commonKeys,
    file: commonKeys,
    news: ['link'],
    miniprogram: ['appid', 'page']
  };
  var msgTypeMap = targetHashMap == null ? void 0 : targetHashMap[msgType];
  return msgTypeMap.every(function (item) {
    return Object.keys(sendParams).includes(item) && sendParams[item];
  });
};
/**
 * 根据文件大小和文件类型计算发送时的消息格式
 * @param targetSize 文件大小
 * @param suffix 文件后缀
 * @returns
 */
var getFileMsgType = function getFileMsgType(targetSize, suffix) {
  if (['jpg', 'png', 'jpeg'].includes(suffix)) return targetSize > MAX_IMAGE_SIZE ? 'file' : 'image';
  if (suffix === 'mp4') return targetSize > MAX_VIDEO_SIZE ? 'file' : 'video';
  return 'file';
};
/**
 * 异常上报
 * @param msg 异常信息
 */
var sendErrorSpm = /*#__PURE__*/function () {
  var _ref = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(msg) {
    var _window4, _window4$Monitor, _msg, _window, _window$wx, _window2, _window2$wx, _parent, _parent$window, _parent$window$wx, _parent2, _parent2$window, _parent2$window$wx, checkJsApi;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _msg = msg || {}; // 500500 新增一些依赖参数日志
          if (!((msg == null ? void 0 : msg.code) === 500500)) {
            _context.next = 8;
            break;
          }
          // 看看wx.config wx.agentConfig是否存在
          _msg.wxData = {
            'config': Boolean((_window = window) == null ? void 0 : (_window$wx = _window.wx) == null ? void 0 : _window$wx.config),
            'agentConfig': Boolean((_window2 = window) == null ? void 0 : (_window2$wx = _window2.wx) == null ? void 0 : _window2$wx.agentConfig),
            'parent.config': Boolean((_parent = parent) == null ? void 0 : (_parent$window = _parent.window) == null ? void 0 : (_parent$window$wx = _parent$window.wx) == null ? void 0 : _parent$window$wx.config),
            'parent.agentConfig': Boolean((_parent2 = parent) == null ? void 0 : (_parent2$window = _parent2.window) == null ? void 0 : (_parent2$window$wx = _parent2$window.wx) == null ? void 0 : _parent2$window$wx.agentConfig)
          };
          // checkJsApi 检查下 sendChatMessage 是否可用
          checkJsApi = function checkJsApi() {
            return new Promise(function (resolve) {
              var _window3, _window3$wx;
              (_window3 = window) == null ? void 0 : (_window3$wx = _window3.wx) == null ? void 0 : _window3$wx.checkJsApi({
                // 需要检测的JS接口列表
                jsApiList: ['sendChatMessage'],
                success: function success(res) {
                  resolve(res);
                }
              });
            });
          };
          _context.next = 7;
          return checkJsApi();
        case 7:
          _msg.checkJsApi = _context.sent;
        case 8:
          (_window4 = window) == null ? void 0 : (_window4$Monitor = _window4.Monitor) == null ? void 0 : _window4$Monitor.sendCustomError({
            message: JSON.stringify(_msg)
          });
          _context.next = 13;
          break;
        case 11:
          _context.prev = 11;
          _context.t0 = _context["catch"](0);
        case 13:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 11]]);
  }));
  return function sendErrorSpm(_x) {
    return _ref.apply(this, arguments);
  };
}();
/**
 * 发送方法
 * @param msgType 消息格式
 * @param sendParams 发送参数
 * @param enterChat 为true时表示发送完成之后顺便进入会话，仅移动端3.1.10及以上版本支持该字段
 * @param overtime 超时时间，超过该时间未收到企微回调，直接给出错误提示，默认值15000，单位为毫秒
 * @param wxVector 是否使用父窗口的wx对象，默认为false
 */
function sendData(msgType, sendParams, enterChat, overtime, wxVector) {
  if (enterChat === void 0) {
    enterChat = false;
  }
  if (overtime === void 0) {
    overtime = 15000;
  }
  if (wxVector === void 0) {
    wxVector = false;
  }
  return new Promise(function (resolve) {
    var innerFun = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _parent3, _parent3$window, _window5, _wxSdk$invoke;
        var targetMsgType, mediaid, wxSdk, result, _result, validParams, res, _result2, originSize, targetSize, _result3, _result4, _res$data, domain, subDomain, id, suffix, name, mediaUrl, params, _res, _result5, content, appid, page, link, title, desc, imgUrl, qwParamsMap, targetParams, timer;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              targetMsgType = msgType; // 企微发送时的消息格式
              mediaid = ''; // 媒体文件上传后获取的唯一标识，3天内有效
              wxSdk = wxVector ? (_parent3 = parent) == null ? void 0 : (_parent3$window = _parent3.window) == null ? void 0 : _parent3$window.wx : (_window5 = window) == null ? void 0 : _window5.wx;
              if (wxSdk) {
                _context2.next = 7;
                break;
              }
              result = {
                code: 100001,
                success: false,
                msg: errorMap[100001]
              };
              sendErrorSpm(result);
              return _context2.abrupt("return", resolve(result));
            case 7:
              if (validateParams(msgType, sendParams)) {
                _context2.next = 11;
                break;
              }
              _result = {
                code: 200001,
                success: false,
                msg: errorMap[200001],
                data: {
                  sendParams: sendParams
                }
              };
              sendErrorSpm(_result);
              return _context2.abrupt("return", resolve(_result));
            case 11:
              // 类型断言，方便后续使用
              validParams = sendParams; // 针对图片、视频、文件，判断其大小，决定以什么格式进行发送
              if (!['image', 'video', 'file'].includes(msgType)) {
                _context2.next = 31;
                break;
              }
              _context2.next = 15;
              return getFileSize(validParams.mediaUrl);
            case 15:
              res = _context2.sent;
              if ((res == null ? void 0 : res.code) === '0') {
                _context2.next = 20;
                break;
              }
              _result2 = {
                code: 300001,
                success: false,
                msg: errorMap[300001],
                data: {
                  callbackData: res,
                  sendParams: sendParams
                }
              };
              sendErrorSpm(_result2);
              return _context2.abrupt("return", resolve(_result2));
            case 20:
              originSize = Number(res.data.size);
              targetSize = originSize / 1024 / 1024; // 文件大小过低，暂不支持发送
              if (!(originSize <= MIN_FILE_SIZE)) {
                _context2.next = 26;
                break;
              }
              _result3 = {
                code: 200003,
                success: false,
                msg: errorMap[200003],
                data: {
                  sendParams: sendParams,
                  fileSize: targetSize
                }
              };
              sendErrorSpm(_result3);
              return _context2.abrupt("return", resolve(_result3));
            case 26:
              if (!(targetSize > MAX_FILE_SIZE)) {
                _context2.next = 30;
                break;
              }
              _result4 = {
                code: 200002,
                success: false,
                msg: errorMap[200002],
                data: {
                  sendParams: sendParams,
                  fileSize: targetSize
                }
              };
              sendErrorSpm(_result4);
              return _context2.abrupt("return", resolve(_result4));
            case 30:
              targetMsgType = getFileMsgType(targetSize, validParams.suffix) || msgType;
            case 31:
              if (!['image', 'video', 'file'].includes(targetMsgType)) {
                _context2.next = 42;
                break;
              }
              domain = validParams.domain, subDomain = validParams.subDomain, id = validParams.id, suffix = validParams.suffix, name = validParams.name, mediaUrl = validParams.mediaUrl;
              params = {
                domain: domain,
                subDomain: subDomain,
                entityId: id,
                fileType: targetMsgType,
                name: name + "." + suffix,
                mediaUrl: mediaUrl
              };
              _context2.next = 36;
              return getMediaId(params);
            case 36:
              _res = _context2.sent;
              if ((_res == null ? void 0 : _res.code) === 500200 && _res != null && _res.success) {
                _context2.next = 41;
                break;
              }
              _result5 = {
                code: 300002,
                success: false,
                msg: errorMap[300002],
                data: {
                  callbackData: _res,
                  sendParams: sendParams
                }
              };
              sendErrorSpm(_result5);
              return _context2.abrupt("return", resolve(_result5));
            case 41:
              mediaid = _res == null ? void 0 : (_res$data = _res.data) == null ? void 0 : _res$data.mediaId;
            case 42:
              content = validParams.content, appid = validParams.appid, page = validParams.page, link = validParams.link, title = validParams.title, desc = validParams.desc, imgUrl = validParams.imgUrl; // 调用企微API需要传递的参数
              qwParamsMap = {
                text: {
                  content: content
                },
                image: {
                  mediaid: mediaid
                },
                video: {
                  mediaid: mediaid
                },
                file: {
                  mediaid: mediaid
                },
                news: {
                  link: link,
                  title: title,
                  desc: desc,
                  imgUrl: imgUrl
                },
                miniprogram: {
                  appid: appid,
                  title: title,
                  imgUrl: imgUrl,
                  page: page
                }
              };
              targetParams = qwParamsMap[targetMsgType];
              console.log('%c消息格式：', 'color: red;', targetMsgType);
              console.log('%c侧边栏发送参数:', 'color: red;', targetParams);
              // 处理企微不给回调的情况
              timer = setTimeout(function () {
                var result = {
                  code: 100002,
                  success: false,
                  msg: errorMap[100002]
                };
                sendErrorSpm(result);
                return resolve(result);
              }, overtime);
              wxSdk.invoke('sendChatMessage', (_wxSdk$invoke = {
                msgtype: targetMsgType,
                enterChat: enterChat
              }, _wxSdk$invoke[targetMsgType] = _extends({}, targetParams), _wxSdk$invoke), function (res) {
                // 进入回调，立即清除定时器
                clearTimeout(timer);
                switch (res.err_msg) {
                  case 'sendChatMessage:ok':
                    resolve({
                      code: 500200,
                      success: true,
                      msg: errorMap[500200],
                      data: {
                        callbackData: res,
                        sendParams: targetParams
                      }
                    });
                    break;
                  case 'sendChatMessage:cancel':
                    resolve({
                      code: 500201,
                      success: false,
                      msg: errorMap[500201],
                      data: {
                        callbackData: res,
                        sendParams: targetParams
                      }
                    });
                    break;
                  default:
                    var _result6 = {
                      code: 500500,
                      success: false,
                      msg: errorMap[500500],
                      data: {
                        callbackData: res,
                        sendParams: targetParams
                      }
                    };
                    sendErrorSpm(_result6);
                    resolve(_result6);
                    break;
                }
              });
            case 49:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function innerFun() {
        return _ref2.apply(this, arguments);
      };
    }();
    innerFun();
  });
}

export { SUB_DOMAIN, sendData };
//# sourceMappingURL=index.esm.js.map
